<template>
    <div class="manifest-ui">
        <HamletTable
            :columns="columns"
            :fetch="fetch"
            :default-per-page="15"
            @onRowClick="openManifest"
        >
            <template #header-label>
                Import manifests
            </template>

            <template #header-controls>
                <b-button
                    v-if="$can('visit', 'administration-import-manifests')"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="btn-icon"
                    title="Create manifest"
                    @click="createManifest"
                >
                    <feather-icon icon="PlusIcon" />
                </b-button>
            </template>

            <template #cell-name="data">
                <div class="font-weight-bold">{{ data.item.name }}</div>
                <small v-if="data.item.description" class="text-muted">
                    {{ data.item.description }}
                </small>
            </template>

        <template #cell-manifestType="data">
            {{ importManifestTitle(data.item.manifestType) }}
            </template>

            <template #cell-status="data">
                <ManifestStatusBadge :status="data.item.status" />
            </template>

            <template #cell-activeVersionId="data">
                <span v-if="data.item.activeVersionId" :title="data.item.activeVersionId">
                    Configured
                </span>
                <span v-else class="text-muted">—</span>
            </template>

            <template #cell-updatedAt="data">
                {{ formatDate(data.item.updatedAt) }}
            </template>
        </HamletTable>
    </div>
</template>

<script>
import {BButton} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {ImportManifestApi} from '@core/api'
import HamletTable from '@core/components/common/HamletTable.vue'
import backendResponse from '@core/mixins/ui/backend-response'
import ManifestStatusBadge from './components/ManifestStatusBadge.vue'
import {getImportManifestTitle} from './manifestContexts'

export default {
    components: {
        BButton,
        HamletTable,
        ManifestStatusBadge,
    },
    directives: {Ripple},
    mixins: [backendResponse],
    data() {
        return {
            columns: [
                {key: 'name', label: 'Name'},
                {key: 'manifestType', label: 'Type'},
                {key: 'status', label: 'Status'},
                {key: 'activeVersionId', label: 'Active version'},
                {key: 'updatedAt', label: 'Updated at'},
            ],
        }
    },
    methods: {
        importManifestTitle(manifestType) {
            return getImportManifestTitle(manifestType)
        },
        fetch(config, callback) {
            ImportManifestApi.list()
                .then(response => {
                    const manifests = Array.isArray(response.data) ? response.data : []
                    const start = (config.page - 1) * config.perPage

                    callback(
                        manifests.length,
                        manifests.slice(start, start + config.perPage)
                    )
                })
                .catch(error => {
                    callback(0, [])
                    this.handleBackendError(error)
                })
        },
        openManifest(manifest) {
            if (!this.$can('visit', 'administration-import-manifests')) {
                return
            }

            this.$router.push({
                name: 'administration-import-product-manifests-manage',
                params: {id: manifest.id},
            })
        },
        createManifest() {
            this.$router.push({name: 'administration-import-product-manifests-new'})
        },
        formatDate(value) {
            return value ? this.$moment(value).format('YYYY-MM-DD HH:mm') : '—'
        },
    },
}
</script>

<style lang="scss">
@import './theme';
</style>

<style lang="scss" scoped>
::v-deep .hamlet-table tbody tr {
    cursor: pointer;
}

::v-deep .hamlet-table td:first-child {
    min-width: 20rem;
    white-space: normal;
}
</style>
